import { getDefaultFormatCodeSettings } from "typescript";

export const pageListeners = {
  detectEditorNavigation: () => {
    let observer = new MutationObserver(pageListeners.toggleControls);
    let programEditor = $("#formmonitor_program").get(0);
    let criteria = { attributes: true, childList: true, subtree: true };
    observer.observe(programEditor, criteria);
  },

  toggleControls: () => {
    $(".goal-wizard-container").is(":visible")
      ? pageListeners.removeControls()
      : pageListeners.restoreControls();
  },

  removeControls: () => {
    $(
      "#saveRecord, #cancelSaveRecord, #saveRecord_bottom, #cancelSaveRecord_bottom"
    ).hide();
  },

  restoreControls: () => {
    $(
      "#saveRecord, #cancelSaveRecord, #saveRecord_bottom, #cancelSaveRecord_bottom"
    ).show();
  },

  customProgramIsSelected: (t, setPageStatus, setMonitorProgramId) => {
    const detectCustom = () => {
      setPageStatus("isCustom", true);
      setMonitorProgramId(null);
    };
    const detectNotCustom = () => {
      setPageStatus("isCustom", false);
    };

    $(function () {
      $("#program_id").on("change", (e: any) => {
        if (e.currentTarget.value == "C") {
          $("#confirm_new_monitor_plan").on("click", detectCustom);

          $("#confirm_new_monitor_plan").off("click", detectNotCustom);
        } else {
          $("#confirm_new_monitor_plan").on("click", detectNotCustom);

          $("#confirm_new_monitor_plan").off("click", detectCustom);
        }
      });
    });
  },

  monitorProgramIsSelected: (action, currentId) => {
    var programIdSelector = new RegExp(/(?<=\/monitor_programs\/)\d+(?=\.xml)/);
    $(document).ajaxComplete((event, request, settings) => {
      if (
        settings.url.includes("monitor_programs/") &&
        settings.type == "GET" &&
        request.status == 200
      ) {
        let newId = programIdSelector.exec(settings.url)[0];
        action(newId);
      }
    });
  },
  programInterviewIsRemoved: (action) => {
    $(function () {
      $(".fa-times").on("click", () => {
        action((prevChange) => prevChange - 1);
      });
    });
  },
  programInterviewIsAdded: (action) => {
    $(function () {
      $(
        "#addUnscheduledInterviewDialogDiv-ok-button, #addInterviewDialogDiv-ok-button"
      ).on("click", () => {
        action((prevChange) => prevChange + 1);
      });
    });
  },

  parseProgramInterviews: (setProfileInterviews, profileInterviews) => {
    var loadedInterviews = [];
    $(".fas, .fa-times").each(function () {
      $(this).is(":visible")
        ? loadedInterviews.push(
            $(this)
              .parent()
              .parent()
              .siblings(".interview_select_cell")
              .find("input")
              .val()
          )
        : null;
    });
    if (
      loadedInterviews.sort().join(",") !== profileInterviews.sort().join(",")
    ) {
      setProfileInterviews(loadedInterviews);
    }
  },
  detectedIds: [],

  detectPatientInterviews: (setCurrentInterviewList) => {
    let loadedInterviews: any = [];
    $(function () {
      const mutated = (mutationList) => {
        $(mutationList[0].target)
          .children(".inline_row")
          .each(function () {
            let foundValue: any = $(this)
              .children(".interview_select_cell")
              .find("input")
              .val();
            loadedInterviews.push(foundValue);
          });
        let vv = loadedInterviews.pop();
        if (loadedInterviews.join(",") != pageListeners.detectedIds.join(",")) {
          pageListeners.detectedIds = loadedInterviews;
          setCurrentInterviewList(loadedInterviews);
        }
        loadedInterviews = [];
      };

      let mutationParams = {
        attributes: false,
        childList: true,
        subtree: true,
      };

      var interviewTable = $("#ms_table").get(0);
      var interviewObserver = new MutationObserver(mutated);

      interviewObserver.observe(interviewTable, mutationParams);
    });
  },

  detectPatientInterviewsOnLoad: (setCurrentInterviewList) => {
    let loadedInterviews = [];
    $(function () {
      $(".inline_row").each(function () {
        loadedInterviews.push(
          $(this).children(".interview_select_cell").find("input").val()
        );
      });
      let i = loadedInterviews.pop();
      setCurrentInterviewList(loadedInterviews);
    });
  },

  detectActiveGoalHistoryTab: (status, setStatus) => {
    $(function () {
      const mutated = (mutationList) => {
        setStatus({
          ...status,
          isActive: mutationList[0].target.className.includes("active"),
        });
      };
      let mutationParams = {
        attributes: true,
        attributeFilter: ["class"],
        childList: false,
        subtree: false,
      };

      var goalHistoryButton = new MutationObserver(mutated);
      var goalsHistoryTab = $("#tabs-goals-history-tab").get(0);

      goalHistoryButton.observe(goalsHistoryTab, mutationParams);
    });
  },
};
